"use client";

import { useEffect, useState } from "react";
import { baseDomainFrom, serviceUrl, type Service } from "@/lib/services";

export function ServiceGrid({
  services,
  baseDomain,
}: {
  services: Service[];
  // Provided server-side (from PORTAL_DOMAIN) so links are absolute in the HTML.
  baseDomain?: string;
}) {
  const [base, setBase] = useState<string | null>(baseDomain || null);

  useEffect(() => {
    // Only when the server didn't supply a domain (local dev): derive it from
    // the portal's own host, e.g. portal.<domain> -> <domain>.
    if (!baseDomain) {
      setBase(baseDomainFrom(window.location.hostname));
    }
  }, [baseDomain]);

  return (
    <div className="grid w-full max-w-4xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {services.map((service) => (
        <a
          key={service.name}
          href={base ? serviceUrl(base, service) : "#"}
          target="_blank"
          rel="noopener noreferrer"
          className="group rounded-2xl border border-white/10 bg-zinc-900/60 p-6 backdrop-blur-sm transition-all hover:-translate-y-0.5 hover:border-teal-400/40 hover:bg-zinc-900"
        >
          <div className="flex items-center justify-between gap-2">
            <h2 className="text-lg font-semibold text-zinc-50">{service.name}</h2>
            <span className="font-mono text-xs text-amber-300/80">
              {service.subdomain}
            </span>
          </div>
          <p className="mt-2 text-sm text-zinc-400">{service.description}</p>
          <span className="mt-4 inline-flex items-center text-sm font-medium text-teal-300 opacity-0 transition-opacity group-hover:opacity-100">
            Ouvrir →
          </span>
        </a>
      ))}
    </div>
  );
}
